import { render, staticRenderFns } from "./SocialApp.vue?vue&type=template&id=b6bf6a9c&scoped=true&"
import script from "./SocialApp.vue?vue&type=script&lang=js&"
export * from "./SocialApp.vue?vue&type=script&lang=js&"
import style0 from "./SocialApp.vue?vue&type=style&index=0&id=b6bf6a9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bf6a9c",
  null
  
)

export default component.exports